import React from 'react';
import { X, Send } from 'lucide-react';
import PhoneInput from './PhoneInput';

const ApplicationModal = ({
                              onClose,
                              applicationData,
                              onChange,
                              onSubmit,
                              isSubmitted,
                              isSubmitting,
                              selectedCar,
                              onGoToThankYouPage // Новый проп для перехода на страницу благодарности
                          }) => {
    // Обработчик изменения способа покупки
    const handlePaymentMethodChange = (e) => {
        const { value } = e.target;
        onChange({
            target: {
                name: 'paymentMethod',
                value
            }
        });
    };

    // Валидация формы
    const isFormValid = () => {
        // Проверяем, что имя заполнено
        if (!applicationData.name || applicationData.name.trim().length < 2) {
            return false;
        }

        // Проверяем, что телефон содержит 11 цифр (российский формат)
        if (!applicationData.phone || applicationData.phone.length !== 11) {
            return false;
        }

        // Проверяем, что выбран способ оплаты
        if (!applicationData.paymentMethod) {
            return false;
        }

        return true;
    };

    // Обработчик отправки формы
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isFormValid()) {
            alert('Пожалуйста, заполните все обязательные поля корректно');
            return;
        }

        // Вызываем оригинальный обработчик отправки
        await onSubmit(e);

        // После успешной отправки переходим на страницу благодарности
        if (onGoToThankYouPage) {
            onGoToThankYouPage();
        }
    };

    // Формируем заголовок модального окна с учетом выбранного автомобиля
    const modalTitle = selectedCar
        ? `Заявка на ${selectedCar.brand} ${selectedCar.model}`
        : 'Оставить заявку';

    return (
        <div className="modal-overlay">
            <div className="modal-container application-modal">
                <div className="modal-header">
                    <h3>{modalTitle}</h3>
                    <button
                        className="modal-close"
                        onClick={onClose}
                    >
                        <X size={20} />
                    </button>
                </div>

                {isSubmitted ? (
                    <div className="application-success">
                        <div className="success-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                        </div>
                        <h4>Заявка успешно отправлена!</h4>
                        <p>Перенаправляем вас на страницу благодарности...</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="application-form">
                        {selectedCar && (
                            <div className="form-group selected-car-info">
                                <div className="selected-car-details">
                                    <img
                                        src={selectedCar.images ? selectedCar.images[0] : selectedCar.image}
                                        alt={`${selectedCar.brand} ${selectedCar.model}`}
                                        className="selected-car-image"
                                    />
                                    <div className="selected-car-text">                                        <h4>{selectedCar.brand} {selectedCar.model}</h4>
                                        <p>Год: {selectedCar.year}, Цена: ₽{Math.round(selectedCar.price).toLocaleString()}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="name">Как вас зовут? *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={applicationData.name}
                                onChange={onChange}
                                required
                                minLength={2}
                                placeholder="Введите ваше имя"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Ваш контактный номер *</label>
                            <PhoneInput
                                id="phone"
                                name="phone"
                                value={applicationData.phone}
                                onChange={onChange}
                                required
                            />
                            <small className="form-hint">Мы принимаем только российские номера телефонов</small>
                        </div>

                        <div className="form-group">
                            <label>Способ покупки *</label>
                            <div className="payment-options">
                                <div className="payment-option">
                                    <input
                                        type="radio"
                                        id="cash"
                                        name="paymentMethod"
                                        value="cash"
                                        checked={applicationData.paymentMethod === 'cash'}
                                        onChange={handlePaymentMethodChange}
                                        required
                                    />
                                    <label htmlFor="cash" className="payment-label">
                                        <div className="payment-icon">💰</div>
                                        <div className="payment-info">
                                            <span className="payment-title">Собственные средства</span>
                                            <span className="payment-desc">Оплата наличными или банковским переводом</span>
                                        </div>
                                    </label>
                                </div>

                                <div className="payment-option">
                                    <input
                                        type="radio"
                                        id="credit"
                                        name="paymentMethod"
                                        value="credit"
                                        checked={applicationData.paymentMethod === 'credit'}
                                        onChange={handlePaymentMethodChange}
                                        required
                                    />
                                    <label htmlFor="credit" className="payment-label">
                                        <div className="payment-icon">💳</div>
                                        <div className="payment-info">
                                            <span className="payment-title">Кредитные средства</span>
                                            <span className="payment-desc">Покупка в кредит через наших банков-партнеров</span>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Опишите, что вас интересует (необязательно)</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="5"
                                value={applicationData.message}
                                onChange={onChange}
                                placeholder="Ваше сообщение..."
                            ></textarea>
                        </div>

                        <div className="form-actions">
                            <button
                                type="submit"
                                className="button primary submit-application"
                                disabled={isSubmitting || !isFormValid()}
                            >
                                {isSubmitting ? (
                                    <>Отправка...</>
                                ) : (
                                    <>
                                        <Send size={16} />
                                        Отправить
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ApplicationModal;